import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import useForm from './useForm';
import Table from '../../../components/UI/Table/Table';
import { useTranslation } from 'react-i18next';
import { LinearProgress } from '@material-ui/core';

const ListOpuUser = (props) => {
  const { displayOptions } = props;
  const {
    attributes,
    actions,
    listOpuUser,
    findAllOpuUsers,
    totalPages,

    loading,
    query,
  } = useForm(displayOptions);

  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('opu-user.title.list')} subtitle={t('opu-user.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <Table
                attributes={attributes}
                actions={actions}
                data={listOpuUser}
                loading={loading}
                search={findAllOpuUsers}
                numberOfPage={totalPages}
                query={query}
                textButton={displayOptions.addButton && t('opu-user.add')}
                linkButton={displayOptions.addButton && '/opu-user/add'}
                pdfTitle="Liste des administrateurs OPU"
              />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListOpuUser;
